import { z } from 'zod';
import type { ChatMessageUsage } from '@/features/global-ai-chat/api/types';
const chatMessageUsageSchema = z.object({
  inputTokens: z.number(),
  outputTokens: z.number(),
  guardrailBlockedAt: z.enum(['input', 'output']).optional(),
  guardrailTextUnits: z.number().optional(),
  guardrailEstimatedUsd: z.number().optional()
});

/** API 由来の `usage` をランタイム検証し、不正・null は undefined に正規化する。 */
export function parseChatMessageUsage(value: unknown): ChatMessageUsage | undefined {
  if (value == null) return undefined;
  const result = chatMessageUsageSchema.safeParse(value);
  return result.success ? result.data : undefined;
}